module.exports = __webpack_public_path__ + "img/coins-line.a60183be.svg";